<template>
  <div v-if="!devices.length" class="empty-list-filler">
    <div class="empty-list-filler-content">
      <icon-devices width="128"
                    height="128"
                    iconColor="#7c65b5"
                    class="empty-list-filler-content-icon" />

      {{ $t("devices.noDevices") }}
    </div>
  </div>

  <div v-else
       class="devices-settings">
    <div class="devices-settings-header">
        <icon-location width="32"
                       height="32"
                       iconColor="#b9b9b9" />

        {{ $t("alerts.deviceLocationAlert") }}
    </div>

    <ul class="device-list">
      <device-list-item v-for="(device, index) in devices"
                        :child-id="child.id"
                        :device-id="device.id"
                        :key="index" />
    </ul>

    <div class="manage-installs" @click="openInstalledDevices">
      {{ $t("manageInstalls") }}
    </div>
  </div>
</template>

<script>
  import DeviceListItem from '@/components/Child/ChildDevices/DeviceListItem'
  import tippy from 'tippy.js'
  import analytics from '@/services/analytics.js'
  import errorNotification from '@/mixins/errorNotification.js'

  export default {
    mixins: [
      errorNotification
    ],

    components: {
      DeviceListItem
    },

    props: {
      childId: {
        type: String,
        required: true
      },
    },

    mounted() {
      this.initInfoTooltip()
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      devices() {
        return this.child.devices
      }
    },

    methods: {
      initInfoTooltip() {
        tippy(this.$refs.primaryDeviceExplanationLabel,  {
          allowHTML: true,
          content: this.$refs.primaryDeviceExplanation,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      },

      openInstalledDevices() {
        analytics.sendEvent('Pk_ManageInstalls_Ellip')

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'devices'
          })

          return
        }

        this.showModal('devices')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-list-filler {
    width: 100%;
    height: 350px;

    display: flex;
    justify-content: center;
    align-items: center;

    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      &-icon {
        margin-bottom: 20px;
      }
    }
  }

  .devices-settings {
    &-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      width: 100%;

      font-size: 14px;
      color: #b9b9b9;

      padding: 6px 0;
    }

    .device-list {
      list-style: none;
      padding: 0;
      margin: 0;

      &:last-child {
        margin-bottom: 20px;
      }
    }

    .manage-installs {
      margin-top: 20px;
      text-align: center;
      cursor: pointer;
    }
  }

  .primary-device-explanation {
    display: flex;
    align-items: center;
    width: 250px;
    border-radius: 2px;
    padding: 0 12px;
  }
</style>
